// extracted by mini-css-extract-plugin
module.exports = {"mention":"ImportedMention__mention___3tfpT"};